import { getClaimDocumentUrl } from '../clients/HrpsClaimsApi';

export const viewClaimDocument = async (
    resellerId: string,
    uploadId: string,
    tenantId: string | undefined = undefined
): Promise<void> => {
    if (resellerId) {
        const result = await getClaimDocumentUrl({ resellerId, uploadId, tenantId });
        window.open(result.documentUrl, '_blank', 'noreferrer');
    }
};
